import { BookMarkedIcon, CpuIcon, LayersIcon, ScaleIcon } from 'lucide-react';

export const comparison: Array<[string, string, string]> = [
  ['Preparar clases técnicas avanzadas', 'Buscás horas sin encontrar nivel suficiente', 'Cirugía robótica, trasplante, TAVI, HIPEC y sala híbrida listos para usar'],
  ['Explicar la IQ moderna en profundidad', 'Tenés datos básicos pero no el análisis completo', 'Atlas anatómico, farmacología completa y anestesiología integrada'],
  ['Responder sobre legislación con autoridad', 'Explicás lo básico pero sin el marco legal completo', 'Compendio legal: Ley 17.132, INET, ANMAT y responsabilidad profesional'],
  ['Hablar de tecnología quirúrgica 2026', 'Datos parciales sin profundidad argumentativa', 'Robótica, IA, sala híbrida, cirugía endovascular e implantes avanzados'],
  ['Identificar cualquier instrumento', 'Reconocés los básicos pero no los especializados', '200 fichas técnicas con algoritmos de identificación visual'],
  ['Posicionarte como docente de vanguardia', 'Tu material es el mismo que el de todos', 'Enseñás lo que ningún libro de texto del sector tiene todavía'],
];

export const premiumModules = [
  [
    'Cirugía Robótica y Plataformas 2026',
    'Sistema Da Vinci: 7 grados de libertad, Endowrist Technology, draping estéril del robot, intercambio de instrumentos, verificación del contador de usos y set de conversión obligatorio. Qué quirófanos argentinos lo tienen y cómo se forma el instrumentador robótico.',
    CpuIcon,
  ],
  [
    'Trasplante, Oncológica Radical y HIPEC',
    'Sistema INCUCAI, Ley 27.447 y rol del instrumentador en el programa de trasplante. Renal, hepático, cardíaco y pulmonar. Resección en bloque, técnica no-touch, Whipple y HIPEC con su bioseguridad especial.',
    LayersIcon,
  ],
  [
    'Sala Híbrida y Cirugía Endovascular',
    'EVAR, TAVI, angioplastia coronaria y procedimientos híbridos. Protección radiológica del instrumentador: delantal de plomo, protector tiroideo y dosímetro. Cómo se organiza el quirófano del futuro.',
    BookMarkedIcon,
  ],
  [
    'Biblioteca Premium de Referencia',
    'Atlas anatómico quirúrgico, farmacología del quirófano, anestesiología para el instrumentador, diccionario de 500+ términos, normas AORN / ISO / JCI e indicadores de calidad con ciclo PDCA.',
    ScaleIcon,
  ],
] as const;
